import { Button, getThemeSize } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const ForgotPasswordButton = styled(Button)`
  font-size: ${({ theme }) => getThemeSize('small', theme)};
`
